import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

const ErrorBoundary: React.FC<{ error?: any }> = ({
    error,
}): React.JSX.Element => {
    error = error || (useRouteError() as any);
    let response: React.JSX.Element;

    if (isRouteErrorResponse(error)) {
        response = (
            <React.Fragment>
                <pre>
                    {error.status} - {error.statusText}
                </pre>
                <pre>{error.data}</pre>
            </React.Fragment>
        );
    } else if (error instanceof Error) {
        response = (
            <React.Fragment>
                <h2>{error.message}</h2>
                <pre>{error.name}</pre>
                {error.stack && <pre>{error.stack}</pre>}
            </React.Fragment>
        );
    } else {
        const stackLines: string[] = error?.error?.message?.split("\n");

        response = (
            <React.Fragment>
                <h2>Unknown Error</h2>
                <pre>
                    {stackLines?.map((line, index) => (
                        <div key={index}>{line}</div>
                    ))}
                </pre>
            </React.Fragment>
        );
    }

    return (
        <main>
            <section className="content errorPage" data-testid="errorBoundary">
                <h1>An error occurred!</h1>
                {response}
            </section>
        </main>
    );
};

export default ErrorBoundary;
